import { render, staticRenderFns } from "./IcoUnsignedAlert.vue?vue&type=template&id=2cebd2dc&lang=html"
import script from "./IcoUnsignedAlert.vue?vue&type=script&lang=js"
export * from "./IcoUnsignedAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports